var exports = {
  "k": "x234b8571--a04bda--container",
  "I": "x234b8571--a04bda--seo-text",
};

module.exports = exports;
